module.exports = __webpack_public_path__ + "static/the-shallows-b7ca067a5dbc35f92436099dace433b0.jpg";